module.exports = __webpack_public_path__ + "img/Refresh - Pink - Selected.c24ef509.png";